import Vue from 'vue';
import Router from 'vue-router';
import VueRouter from 'vue-router';


// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/table',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/BaseTable.vue'),
                    meta: { title: '基础表格' }
                },
                {
                    path: '/form',
                    component: () => import(/* webpackChunkName: "form" */ '../components/page/BaseForm.vue'),
                    meta: { title: '基本表单' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/Upload.vue'),
                    meta: { title: '文件上传' }
                },

                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/index',
                    component: () => import(/* webpackChunkName: "index" */ '../views/index/index'),
                    meta: { title: '首页' }
                },
                {
                    path: '/homePage',
                    component: () => import(/* webpackChunkName: "index" */ '../views/homePage/homePage'),
                    meta: { title: '发起仲裁' }
                },
                {
                    path: '/contract',
                    component: () => import(/* webpackChunkName: "contract" */ '../views/contract/contract'),
                    meta: { title: '合同管理' }
                },
                {
                    path: '/detailsPage',
                    component: () => import(/* webpackChunkName: "contract" */ '../views/contract/components/detailsPage'),
                    meta: { title: '合同详情' }
                },
                {
                    path: '/wholeContract',
                    component: () => import(/* webpackChunkName: "contract" */ '../views/wholeContract/wholeContract'),
                    meta: { title: '全部合同' }
                },
                {
                    path: '/evidenceList',
                    component: () => import(/* webpackChunkName: "evidenceList" */ '../views/contract/components/evidenceList'),
                    meta: { title: '保存证据' }
                },
                //企业管理员 保存证据
                {
                    path: '/preserveEvidence',
                    component: () => import(/* webpackChunkName: "evidenceList" */ '../views/wholeContract/components/preserveEvidence'),
                    meta: { title: '保存证据' }
                },
                {
                    path: '/arbitrate',
                    component: () => import(/* webpackChunkName: "evidenceList" */ '../views/contract/components/arbitrate'),
                    meta: { title: '转入仲裁' }
                },
                //企业管理员 转入仲裁
                {
                    path: '/transferCase',
                    component: () => import(/* webpackChunkName: "evidenceList" */ '../views/wholeContract/components/transferCase'),
                    meta: { title: '转入仲裁' }
                },
                {
                    path: '/initiatingContract',
                    component: () => import(/* webpackChunkName: "initiatingContract" */ '../views/initiatingContract/initiatingContract'),
                    meta: { title: '发起合同' }
                },
                {
                    path: '/formwork',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/formwork'),
                    meta: { title: '模板发起' }
                },
                {
                    path: '/formPage',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/components/formPage'),
                    meta: { title: '表单数据' }
                },
                {
                    path: '/draftPage',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/components/draftPage'),
                    meta: { title: '草稿数据' }
                },
                {
                    path: '/manuscriptPage',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/components/manuscriptPage'),
                    meta: { title: '草稿数据' }
                },
                {
                    path: '/signatureInformation',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/components/signatureInformation'),
                    meta: { title: '合同签署人' }
                },
                {
                    path: '/iframePage',
                    component: () => import(/* webpackChunkName: "formwork" */ '../views/formwork/components/iframePage'),
                    meta: { title: '填写合同' }
                },
                {
                    path: '/signingArea',
                    component: () => import(/* webpackChunkName: "signingArea" */ '../views/signPdf/components/signingArea'),
                    meta: { title: '签署' }
                },
                {
                    path: '/basicInformation',
                    component: () => import(/* webpackChunkName: "basicInformation" */ '../views/formwork/components/basicInformation'),
                    meta: { title: '合同信息' }
                },
                {
                    path: '/InitiateTemplate',
                    component: () => import(/* webpackChunkName: "InitiateTemplate" */ '../views/InitiateTemplate/InitiateTemplate'),
                    meta: { title: '发起模板' }
                },
                {
                    path: '/evidence',
                    component: () => import(/* webpackChunkName: "evidence" */ '../views/evidence/evidence'),
                    meta: { title: '证据存证' }
                },
                {
                    path: '/particulars',
                    component: () => import(/* webpackChunkName: "details" */ '../views/evidence/components/particulars'),
                    meta: { title: '证据详情' }
                },
                {
                    path: '/supplement',
                    component: () => import(/* webpackChunkName: "supplement" */ '../views/evidence/components/supplement'),
                    meta: { title: '补充证据' }
                },
                {
                    path: '/draftBox',
                    component: () => import(/* webpackChunkName: "supplement" */ '../views/draftBox/draftBox'),
                    meta: { title: '草稿箱' }
                },
                {
                    path: '/messagePage',
                    component: () => import(/* webpackChunkName: "supplement" */ '../views/index/components/messagePage'),
                    meta: { title: '消息详情' }
                },
                {
                    path: '/case',
                    component: () => import(/* webpackChunkName: "case" */ '../views/case/case'),
                    meta: { title: '案件管理' }
                },
                {
                    path: '/caseDetails',
                    component: () => import(/* webpackChunkName: "caseDetails" */ '../views/case/components/caseDetails'),
                    meta: { title: '案件详情' }
                },
                {
                    path: '/message',
                    component: () => import(/* webpackChunkName: "order" */ '../views/message/message'),
                    meta: { title: '我的消息' }
                },
                {
                    path: '/lawCase',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/lawCase'),
                    meta: { title: '仲裁案件管理' }
                },
                {
                    path: '/dealWith',
                    component: () => import(/* webpackChunkName: "order" */ '../views/particulars/dealWith'),
                    meta: { title: '仲裁案件详情' }
                },
                {
                    path: '/applicantPage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/applicantPage'),
                    meta: { title: '申请人证据' }
                },
                {
                    path: '/initiate',
                    component: () => import(/* webpackChunkName: "order" */ '../views/homePage/components/initiate'),
                    meta: { title: '仲裁发起立案' }
                },
                {
                    path: '/testimony',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/testimony'),
                    meta: { title: '证据材料' }
                },
                {
                    path: '/defenseEvidence',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/defenseEvidence'),
                    meta: { title: '答辩证据' }
                },
                {
                    path: '/replenish',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/replenish'),
                    meta: { title: '补充证据' }
                },
                {
                    path: '/batchImport',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/batchImport'),
                    meta: { title: '仲裁批量导入' }
                },
                {
                    path: '/checkMessage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/checkMessage'),
                    meta: { title: '查看留言' }
                },
                {
                    path: '/mediate',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/mediate'),
                    meta: { title: '调解管理' }
                },
                {
                    path: '/mediationFiling',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/mediationFiling'),
                    meta: { title: '调解发起立案' }
                },
                {
                    path: '/batchImportCase',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/batchImportCase'),
                    meta: { title: '调解批量导入' }
                },
                {
                    path: '/mediateList',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/mediateList'),
                    meta: { title: '调解清单' }
                },
                {
                    path: '/mediateSupplement',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/mediateSupplement'),
                    meta: { title: '补充证据' }
                },
                {
                    path: '/mediateCaseDetail',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/mediateCaseDetail'),
                    meta: { title: '案件详情' }
                },
                {
                    path: '/transferMediate',
                    component: () => import(/* webpackChunkName: "order" */ '../views/contract/components/transferMediate'),
                    meta: { title: '转为调解案件' }
                },
                {
                    path: '/convertAll',
                    component: () => import(/* webpackChunkName: "order" */ '../views/wholeContract/components/convertAll'),
                    meta: { title: '转为调解案件' }
                },
                {
                    path: '/filingInformation',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/filingInformation'),
                    meta: { title: '修改立案信息' }
                },
                {
                    path: '/editMediationPage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/mediate/components/editMediationPage'),
                    meta: { title: '修改调解信息' }
                },
                {
                    path: '/basicInformationpay',
                    component: () => import(/* webpackChunkName: "order" */ '../views/formwork/components/basicInformationpay'),
                    meta: { title: '签署合同' }
                },
                {
                    path: '/formInformationpay',
                    component: () => import(/* webpackChunkName: "order" */ '../views/formwork/components/formInformationpay'),
                    meta: { title: '签署合同' }
                },
                {
                    path: '/orderList',
                    component: () => import(/* webpackChunkName: "order" */ '../views/orderManagement/orderList'),
                    meta: { title: '订单管理' }
                },
                {
                    path: '/insuranceFile',
                    component: () => import(/* webpackChunkName: "order" */ '../views/lawCase/components/insuranceFile'),
                    meta: { title: '查看保险材料' }
                },
                {
                    path: '/insurePage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/insurePage'),
                    meta: { title: '投保案件管理' }
                },
                {
                    path: '/uploadMaterial',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/uploadMaterial'),
                    meta: { title: '上传保险材料' }
                },
                {
                    path: '/leaveMessage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/leaveMessage'),
                    meta: { title: '查看留言' }
                },
                {
                    path: '/insurancePolicy',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/insurancePolicy'),
                    meta: { title: '确认保单保函' }
                },
                {
                    path: '/viewInsurePage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/viewInsurePage'),
                    meta: { title: '查看投保单' }
                },
                {
                    path: '/uploadSealedInsure',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/uploadSealedInsure'),
                    meta: { title: '上传已盖章投保单' }
                },
                {
                    path: '/insuranceMessage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/insuranceMessage'),
                    meta: { title: '保险消息列表' }
                },
                {
                    path: '/chargeDetail',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/chargeDetail'),
                    meta: { title: '查看收费信息' }
                },
                {
                    path: '/uploadPayment',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/uploadPayment'),
                    meta: { title: '上传缴费信息' }
                },
                {
                    path: '/allMaterialsPage',
                    component: () => import(/* webpackChunkName: "order" */ '../views/insure/components/allMaterialsPage'),
                    meta: { title: '查看全部材料和文书' }
                },
                {
                    path: '/mediationCenter',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/mediationCenter'),
                    meta: { title: '调解中心案件管理' }
                },
                {
                    path: '/mediationFiling_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/mediationFiling_center'),
                    meta: { title: '商事调解立案' }
                },
                {
                    path: '/batch_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/batch_center'),
                    meta: { title: '批量导入案件' }
                },
                {
                    path: '/mediateList_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/mediateList_center'),
                    meta: { title: '调解中心清单' }
                },
                {
                    path: '/mediateSupplement_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/mediateSupplement_center'),
                    meta: { title: '上传补充证据' }
                },
                {
                    path: '/details_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/details_center'),
                    meta: { title: '案件详情' }
                },
                {
                    path: '/editInformation_center',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/editInformation_center'),
                    meta: { title: '修改立案信息' }
                },
                {
                    path: '/loseDetail',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/contract/components/loseDetail'),
                    meta: { title: '合同详情' }
                },
                {
                    path: '/templatePage',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templatePage/templatePage'),
                    meta: { title: '模板列表' }
                },
                {
                    path: '/addTemplate',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templatePage/addTemplate'),
                    meta: { title: '新增模板' }
                },
                {
                    path: '/preview',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templatePage/preview'),
                    meta: { title: '预览模板' }
                },
                {
                    path: '/importMediationCase',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/mediationCenter/components/importMediationCase'),
                    meta: { title: '上传调解案件' }
                },
                {
                    path: '/clueList',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/clueList.vue'),
                    meta: { title: '线索管理列表' }
                },
                {
                    path: 'importClues',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/components/importClues.vue'),
                    meta: { title: '导入线索' }
                },
                {
                    path: 'clueDetails',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/components/clueDetails.vue'),
                    meta: { title: '线索详情' }
                },
                {
                    path: 'addFollowUp',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/components/addFollowUp.vue'),
                    meta: { title: '添加跟进记录' }
                },
                {
                    path:'allCallLog',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/components/allCallLog.vue'),
                    meta: { title: '全部通话记录' }
                },
                {
                    path: 'callStatistics',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/callCenter/components/callStatistics.vue'),
                    meta: { title: '通话统计' }
                },
                {
                    path: 'service',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/service/service.vue'),
                    meta: { title: '服务管理' }
                },
                {
                    path: 'templateList',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templateManagement/templateList.vue'),
                    meta: { title: '模板管理' }
                },
                {
                    path: 'addTemplatePage',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templateManagement/components/addTemplatePage.vue'),
                    meta: { title: '新增模板' }
                },
                {
                    path: 'signDeploy',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templateManagement/components/signDeploy.vue'),
                    meta: { title: '签署方配置' }
                },
                {
                    path: 'staffList',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templateManagement/components/staffList.vue'),
                    meta: { title: '企业员工列表' }
                },
                {
                    path: 'authorizedList',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/templateManagement/components/authorizedList.vue'),
                    meta: { title: '已授权员工列表' }
                },
                {
                    path: 'directInitiation',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/directInitiation/directInitiation.vue'),
                    meta: { title: '直接发起' }
                },
                {
                    path: 'directInitiation_pay',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/directInitiation_pay/directInitiation_pay.vue'),
                    meta: { title: '直接发起' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path:'/visualization',
            component: () => import(/* webpackChunkName: "visualization" */ '../views/visualization/visualization'),
            meta: { title: '可视化' },
        },
        {
            path: '/registered',
            component: () => import(/* webpackChunkName: "registered" */ '../views/registered/registered'),
            meta: { title: 'registered' }
        },
        {
            path: '/personalCenter',
            component: () => import(/* webpackChunkName: "personalCenter" */ '../views/personalCenter/personalCenter'),
            meta: { title: 'personalCenter' },
            redirect: '/personal',
            children: [
                {
                    path: '/personal',
                    component: () => import(/* webpackChunkName: "personal" */ '../views/personal/personal.vue')
                },
                {
                    path: '/accounts',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/personal/accounts.vue')
                },
                {
                    path: '/seal',
                    component: () => import(/* webpackChunkName: "seal" */ '../views/personal/seal.vue')
                },
                {
                    path: '/aboutUs',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/personal/aboutUs.vue')
                },
                {
                    path: '/billRecord_gr',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/personal/billRecord_gr.vue')
                },
                {
                    path:'/rechargeRecord_gr',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/personal/rechargeRecord_gr.vue')
                },
                {
                    path: '/refundRecord_gr',
                    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/personal/refundRecord_gr.vue')

                }

            ]
        },
        // 企业中心
        {
            path: '/enterpriseCenter',
            component: () => import(/* webpackChunkName: "enterpriseCenter" */ '../views/enterpriseCenter/enterpriseCenter'),
            meta: { title: 'enterpriseCenter' },
            redirect: '/management',
            children: [
                {
                    path: '/management',
                    component: () => import(/* webpackChunkName: "management" */ '../views/enterprise/components/management')
                },
                {
                    path: '/employeeList',
                    component: () => import(/* webpackChunkName: "management" */ '../views/enterprise/components/employeeList')
                },
                {
                    path: '/enterprise',
                    component: () => import(/* webpackChunkName: "enterprise" */ '../views/enterprise/enterprise')
                },
                {
                    path: '/member',
                    component: () => import(/* webpackChunkName: "enterprise" */ '../views/enterprise/components/member')

                },
                {
                    path: '/department',
                    component: () => import(/* webpackChunkName: "department" */ '../views/enterprise/components/department')

                },
                {
                    path: '/sealManagement',
                    component: () => import(/* webpackChunkName: "sealManagement" */ '../views/enterprise/components/sealManagement')
                },
                {
                    path: '/billsList',
                    component: () => import(/* webpackChunkName: "billsList" */ '../views/enterprise/components/billsList.vue'),
                    meta: { title: '账单管理列表' }
                },
                {
                    path: '/seatsList',
                    component: () => import(/* webpackChunkName: "billsList" */ '../views/enterprise/components/seatsList.vue'),
                    meta: { title: '坐席管理列表' }
                },
                {
                    path: '/billRecord',
                    component: () => import(/* webpackChunkName: "billsList" */ '../views/enterprise/components/billRecord.vue'),
                    meta: { title: '计费记录列表' }
                },
                {
                    path: '/rechargeRecord',
                    component: () => import(/* webpackChunkName: "billsList" */ '../views/enterprise/components/rechargeRecord.vue'),
                    meta: { title: '充值记录列表' }
                },
                {
                    path: '/refundRecord',
                    component: () => import(/* webpackChunkName: "billsList" */ '../views/enterprise/components/refundRecord.vue'),
                    meta: { title: '退费记录列表' }
                }

            ]
        },
        // 运营商中心
        {
            path: '/operatorCenter',
            component: () => import(/* webpackChunkName: "enterpriseCenter" */ '../views/operatorCenter/operatorCenter.vue'),
            meta: { title: 'operatorCenter' },
            redirect: '/myCode',
            children: [
                {
                    path: '/myCode',
                    component: () => import(/* webpackChunkName: "management" */ '../views/operator/myCode.vue')
                },
                {
                    path: '/customerList_qy',
                    component: () => import(/* webpackChunkName: "management" */ '../views/operator/customerList_qy.vue')
                },
                {
                    path: '/customerList_gr',
                    component: () => import(/* webpackChunkName: "management" */ '../views/operator/customerList_gr.vue')
                }
            ]
        },
        //签署页面
        {
            path: '/signPage',
            component: () => import(/* webpackChunkName: "enterpriseCenter" */ '../views/signPdf/signPage')
            // meta: {title: ''},
        },
        {
            path: '/forget',
            component: () => import(/* webpackChunkName: "forget" */ '../views/forget/forget'),
            meta: { title: 'forget' }
        },
        {
            path: '/noLanding',
            component: () => import(/* webpackChunkName: "order" */ '../views/login/components/noLanding')
            // meta: {title: '案件详情'}
        },
        {
            path: '*',
            redirect: '/404'
        }

    ]
});
